import { compose } from 'recompose'
import getSubscriptionDescription from '../../utils/getSubscriptionDescription'
import { withI18next } from '../../lib/withI18next'

const CartTable = ({ t, cart, onRemoveFromCart, removableItems, tax, total, subtotal }) => (
  <div className="ma-cart-table">
    <table className="table is-bordered is-fullwidth">
      <thead>
        <tr>
          { removableItems ? <th /> : null }
          <th>{t('common:SKU')}</th>
          <th>{t('common:description')}</th>
          <th>{t('common:price')}</th>
        </tr>
      </thead>
      <tbody>
        { cart.items.map((item, index) => (
          <tr key={index} className="ma-remove-icon">
            { removableItems ? <td onClick={() => onRemoveFromCart(item.id)}>
              <span className="icon cart-delete"><i className="mdi mdi-minus-circle-outline" aria-hidden="true" /></span>
            </td> : null }
            <td>{item.id}</td>
            <td>{getSubscriptionDescription(item.id, t).title}</td>
            <td>${item.price}</td>
          </tr>
      )) }
      </tbody>
      <tfoot>
        { subtotal &&
          <tr>
            <td colSpan={removableItems ? 3 : 2} className="has-text-right is-borderless">
              {t('sub-total')}:
            </td>
            <td className="has-text-right is-borderless">${subtotal}</td>
          </tr>
        }
        { tax &&
          <tr>
            <td colSpan={removableItems ? 3 : 2} className="has-text-right is-borderless">
              {t('tax')}:
            </td>
            <td className="has-text-right is-borderless">${tax}</td>
          </tr>
        }
        { total &&
          <tr>
            <td colSpan={removableItems ? 3 : 2} className="has-text-right is-borderless">
              {t('total')}:
            </td>
            <td className="has-text-right is-borderless">${total}</td>
          </tr>
        }
      </tfoot>
    </table>
  </div>
)

export default compose(
  withI18next('common')
)(CartTable)



// WEBPACK FOOTER //
// ./components/CartTable/index.js